import { createSlice } from "@reduxjs/toolkit";
import {
  AllCartCollactionThunk,
  GetSingleCartCollactionThunk,
  AllWishlistCollactionThunk,
  GetSingleWishlistCollactionThunk,
  AllTotalsHomepageThunk
} from "./thunk";

const initialState = {
  cart: [],
  singlecart: null,
  wishlist: [],
  singlewishlist: null,
  homepagetotals: [],
  loading: false,
  error: null,
  successMessage: null,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  extraReducers: (builder) => {
    builder
      // -------------------- ALL cart --------------------
      .addCase(AllCartCollactionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllCartCollactionThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.cart = action.payload?.data || [];
      })
      .addCase(AllCartCollactionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- SINGLE cart --------------------
      .addCase(GetSingleCartCollactionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleCartCollactionThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singlecart = action.payload?.data || null;
      })
      .addCase(GetSingleCartCollactionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // -------------------- ALL Wishlist --------------------
      .addCase(AllWishlistCollactionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllWishlistCollactionThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.wishlist = action.payload?.data || [];
      })
      .addCase(AllWishlistCollactionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- SINGLE Wishlist --------------------
      .addCase(GetSingleWishlistCollactionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleWishlistCollactionThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singlewishlist = action.payload?.data || null;
      })
      .addCase(GetSingleWishlistCollactionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- ALL Wishlist --------------------
      .addCase(AllTotalsHomepageThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllTotalsHomepageThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.homepagetotals = action.payload?.data || [];
      })
      .addCase(AllTotalsHomepageThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default cartSlice.reducer;
